module.exports = __webpack_public_path__ + "static/01-0c987412bc8800f946175ec85332034d.jpg";